import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffCompanyLawModificationRequest,
  StaffCompanyLawModificationResponse,
  StaffCompanyLawModificationsService,
} from "lib-klab-sdks";
import { CompanyLawModificationsPort } from "../../../app/ports/organization/company-law-modifications.port";
import {
  CompanyLawModification,
  CompanyLawModificationRequest,
} from "../../../domain/models/organization/company-law-modification.model";

@Injectable({ providedIn: "root" })
export class CompanyLawModificationsPortAdapter implements CompanyLawModificationsPort {
  constructor(private readonly api: StaffCompanyLawModificationsService) {}

  list(): Observable<CompanyLawModification[]> {
    return this.api.list().pipe(map((items) => items.map(mapModification)));
  }

  getByCompanyId(companyId: number): Observable<CompanyLawModification> {
    return this.api.getByCompanyId(companyId).pipe(map(mapModification));
  }

  update(
    companyId: number,
    request: CompanyLawModificationRequest,
  ): Observable<CompanyLawModification> {
    return this.api
      .update(companyId, request as StaffCompanyLawModificationRequest)
      .pipe(map(mapModification));
  }
}

function mapModification(
  item: StaffCompanyLawModificationResponse,
): CompanyLawModification {
  return {
    id: item.companyLawModificationId,
    companyId: item.companyId,
    modifications: item.modifications.map((modification) => ({
      ...modification,
    })),
  };
}
